import * as React from "react";
const SvgAxe = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      fill="currentColor"
      d="m42 32 10 6c0 4-2 6-6 7l-3-5-4-4zm-7.89 17.84-1.99-1.51L39.19 39 41 40.81z"
    />
  </svg>
);
export default SvgAxe;
